import { ReactElement } from 'react';

import { reactToWebComponent } from './react-to-web-component';

export const defineWebComponents = (webComponentMap = new Map()) => {
  webComponentMap.forEach((reactElement: ReactElement, webComponentTagName: string) => {
    if (!customElements.get(webComponentTagName)) {
      const webComponentElement = reactToWebComponent(reactElement);
      customElements.define(webComponentTagName, webComponentElement);
      console.info('webComponent defined:', webComponentTagName);
    }
  });
};
